var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('tabs',{staticClass:"border-b-gris pt-2",attrs:{"tabs":_vm.rutas}}),_c('div',{staticClass:"p-2 overflow-auto custom-scroll",staticStyle:{"height":"calc(100vh - 182px)"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }